document.addEventListener("DOMContentLoaded", (event) => {

    const advantages = document.querySelectorAll('.advantages');

    if (advantages) {
        advantages.forEach(advantages_block => {

            const list = advantages_block.querySelector('.advantages__list');
            const next = advantages_block.querySelector('.advantages__next-btn') || null;
            const prev = advantages_block.querySelector('.advantages__prev-btn') || null;
            const nav_container = advantages_block.querySelector('.advantages__nav') || null;

            const swiper = new Swiper(list, {
                loop: true,
                loopPreventsSliding: true,
                // centeredSlidesBounds: true,
                centerInsufficientSlides: true,
                // centeredSlides: true,
                autoplay: {
                    delay: 7500,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: next,
                    prevEl: prev,
                },
                on: {
                    init: function () { toggleCustomNavigation(this, nav_container); },
                    resize: function () { toggleCustomNavigation(this, nav_container); },
                },
                slidesPerView: 1.15,
                spaceBetween: 20,
                autoHeight: true,
                breakpoints: {
                    440: {
                        slidesPerView: 1.2,
                        spaceBetween: 24,
                    },
                    500: {
                        slidesPerView: 2,
                        spaceBetween: 24,
                    },
                    748: {
                        slidesPerView: 2.5,
                        spaceBetween: 21,
                    },
                    991: {
                        slidesPerView: 3.2,
                        spaceBetween: 21,
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 21,
                    }
                }
            });

        });

        function toggleCustomNavigation(swiperInstance, nav_container) {
            if (swiperInstance.params.navigation && nav_container) {
                if (swiperInstance.slides.length <= swiperInstance.params.slidesPerView) {
                    nav_container.style.display = 'none';
                } else {
                    nav_container.style.display = 'flex';
                }
            }
        }
    }

});
